"use strict";

import { Collection } from "Collection";
import { FormFilterFieldEventsModel } from 'Models/FormFilterFieldEventsModel';
import { Objects } from "Constants/objects";
export var FormFilterFieldEvents = Collection.extend({
  model: FormFilterFieldEventsModel,
  object: Objects.SysFormFilterFieldEvents
});